var _module_exports ="<div marked=\"component.Content\"></div>";;
var path = '/app/shared/odd/oddPublic/oddComponent.StaticText.Default.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;